<app-overlay-loader *ngIf="loader"></app-overlay-loader>
<div class="container-fluid p-2">
  <div class="row">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4>
            Manage Course Schedule
          </h4>
          <p-dropdown [options]="courses" [(ngModel)]="selectedCourse" optionLabel="courseName" optionValue="courseID" [style]="{ width: '100%' }" (onChange)="changeCourses()"></p-dropdown>
        </div>
        <div class="card-body">
          <!-- Subject Management Section -->
          <div class="row mb-4">
            <div class="col-md-6">
              <div class="card p-4 h-100">
                <h5 class="fw-bold mb-3">Select System</h5>
                <label for="subjectSelect" class="form-label">System Name</label>
                <p-dropdown
                  [options]="subjects"
                  [(ngModel)]="selectedSubject"
                  optionLabel="name"
                  [placeholder]="'-- Select a system --'"
                  (onChange)="selectSubject($event.value)"
                  [showClear]="true"
                  [style]="{ width: '100%' }"
                ></p-dropdown>
                <button class="btn btn-success w-100 mt-4" [disabled]="!selectedSubject" (click)="enableEdit = true">
                  <i class="fas fa-plus mr-2"></i>Add Subject
                </button>
              </div>
            </div>
            <div class="col-md-1 d-flex align-items-center justify-content-center">
              <div class="or-divider text-center">
                <span class="bg-white px-2 text-muted">or</span>
              </div>
            </div>
            <div class="col-md-5">
              <div class="card p-4 h-100">
                <h5 class="fw-bold mb-3">Create New System</h5>
                <form [formGroup]="subjectForm" (ngSubmit)="onSubmitSubject()">
                  <div class="mb-3">
                    <label for="subjectName" class="form-label">System Name</label>
                    <input type="text" class="form-control" id="subjectName" formControlName="name" placeholder="Enter system name">
                  </div>
                  <button type="submit" class="btn btn-primary w-100" [disabled]="!subjectForm.valid">
                    <i class="fas fa-plus mr-2"></i>Add System
                  </button>
                </form>
              </div>
            </div>
          </div>

          <!-- Subject Form -->
          <form [formGroup]="systemForm" (ngSubmit)="onSubmitSystem()" class="mb-4" *ngIf="enableEdit">
            <div class="card border-primary">
              <div class="card-header bg-light">
                <h5 class="mb-0">Add Subject to {{ selectedSubject?.name }}</h5>
              </div>
              <div class="card-body mt-3">
                <div class="row g-3">
                  <div class="col-md-6">
                    <div class="form-floating">
                    <label for="systemName">Subject Name</label>
                      <input type="text" class="form-control" id="systemName" formControlName="name" placeholder="Enter subject name">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-floating">
                        <label for="systemName">Duration (in hours and minutes)</label>
                      <div class="input-group">
                        <input type="number" class="form-control" id="hours" formControlName="hours" placeholder="Hours" min="0">
                        <span class="input-group-text">hrs</span>
                        <input type="number" class="form-control ml-3" id="minutes" formControlName="minutes" placeholder="Minutes" min="0" max="59">
                        <span class="input-group-text">mins</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mt-3">
                    <div class="form-floating">
                        <label for="videoLink">Video Link (VdoCipher ID)</label>
                      <input type="url" class="form-control" id="videoLink" formControlName="videoLink" placeholder="Enter video URL">
                    </div>
                  </div>
                  <div class="col-12 mt-3">
                    <label for="content" class="form-label">Content</label>
                    <ckeditor [editor]="Editor" formControlName="content" [config]="editorConfig"></ckeditor>
                  </div>
                  <div class="col-12 d-flex gap-2 justify-content-end mt-4">
                    <button type="button" class="btn btn-secondary mr-3" (click)="cancelSystem()">
                      <i class="fas fa-times mr-2"></i>Cancel
                    </button>
                    <button type="submit" class="btn btn-primary" [disabled]="!systemForm.valid">
                      <i class="fas fa-save mr-2"></i>Add Subject
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <hr>

          <!-- Schedule Display (Redesigned) -->
          <div class="mt-4">
            <h5 class="mb-3">
              <i class="fas fa-list mr-2"></i>Current Schedule
            </h5>
            <div class="table-responsive">
              <table class="table table-bordered schedule-table">
                <thead class="table-light">
                  <tr>
                    <th>System</th>
                    <th>Subject</th>
                    <th>Content</th>
                    <th>Number of Sessions</th>
                    <th>Duration</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let subject of subjects">
                    <tr>
                      <td [attr.rowspan]="subject.systems.length + 1" class="align-middle fw-bold">
                        {{ subject.name }}
                        <div class="action-buttons mt-2">
                          <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text" (click)="editSubject(subject)"></button>
                          <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text" style="color: red;" (click)="deleteSubject(subject)"></button>
                        </div>
                      </td>
                      <td colspan="2"></td>
                      <td class="align-middle text-center fw-bold">{{ subject.systems.length }}</td>
                      <td class="align-middle text-center fw-bold">
                        {{ getTotalDuration(subject.systems) }}
                      </td>
                      <td></td>
                    </tr>
                    <ng-container *ngFor="let system of subject.systems">
                      <tr>
                        <td class="align-middle">{{ system.name }}</td>
                        <td [innerHTML]="system.content | safeHtml"></td>
                        <td class="align-middle text-center"></td>
                        <td class="align-middle text-center">
                          {{ getSystemDuration(system) }}
                        </td>
                        <td class="align-middle">
                          <div class="action-buttons">
                            <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text" (click)="editSystem(system)"></button>
                            <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text" style="color: red;" (click)="deleteSystem(system)"></button>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Edit Subject Dialog -->
<p-dialog [(visible)]="showSubjectDialog" [style]="{width: '50vw'}" [header]="subjectDialogHeader" [modal]="true">
  <form [formGroup]="subjectForm" class="subject-form">
    <div class="form-field">
      <label for="subjectName">System Name</label>
      <input id="subjectName" type="text" pInputText formControlName="name" class="w-full" placeholder="Enter system name">
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideSubjectDialog()"></button>
    <button pButton label="Save" icon="pi pi-check" class="p-button-primary" (click)="saveSubject()"></button>
  </ng-template>
</p-dialog>

<!-- Delete Subject Confirmation Dialog -->
<p-dialog [(visible)]="showDeleteSubjectDialog" [style]="{width: '30vw'}" header="Confirm Delete" [modal]="true">
  <p>Are you sure you want to delete this system and all its subjects?</p>
  <ng-template pTemplate="footer">
    <button pButton label="No" icon="pi pi-times" class="p-button-text" (click)="hideDeleteSubjectDialog()"></button>
    <button pButton label="Yes" icon="pi pi-check" class="p-button-danger" (click)="confirmDeleteSubject()"></button>
  </ng-template>
</p-dialog>

<!-- Edit System Dialog -->
<p-dialog [(visible)]="showSystemDialog" [style]="{width: '50vw'}" [header]="systemDialogHeader" [modal]="true">
  <form [formGroup]="systemForm" class="system-form">
    <div class="form-field">
      <label for="systemName">Subject Name</label>
      <input id="systemName" type="text" pInputText formControlName="name" class="w-full" placeholder="Enter subject name">
    </div>

    <div class="form-field">
      <label>Duration (in hours and minutes)</label>
      <div class="duration-inputs">
        <div class="input-group">
          <input type="number" pInputText formControlName="hours" placeholder="Hours" min="0">
          <span class="input-group-text">hrs</span>
          <input type="number" pInputText formControlName="minutes" placeholder="Minutes" min="0" max="59">
          <span class="input-group-text">mins</span>
        </div>
      </div>
    </div>

    <div class="form-field">
      <label for="videoLink">Video Link (VdoCipher ID)</label>
      <input id="videoLink" type="url" pInputText formControlName="videoLink" class="w-full" placeholder="Enter video URL">
    </div>

    <div class="form-field">
      <label for="content">Content</label>
      <ckeditor [editor]="Editor" formControlName="content" [config]="editorConfig"></ckeditor>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideSystemDialog()"></button>
    <button pButton label="Save" icon="pi pi-check" class="p-button-primary" (click)="saveSystem()"></button>
  </ng-template>
</p-dialog>

<!-- Delete System Confirmation Dialog -->
<p-dialog [(visible)]="showDeleteSystemDialog" [style]="{width: '30vw'}" header="Confirm Delete" [modal]="true">
  <p>Are you sure you want to delete this subject?</p>
  <ng-template pTemplate="footer">
    <button pButton label="No" icon="pi pi-times" class="p-button-text" (click)="hideDeleteSystemDialog()"></button>
    <button pButton label="Yes" icon="pi pi-check" class="p-button-danger" (click)="confirmDeleteSystem()"></button>
  </ng-template>
</p-dialog>
